module.exports = __webpack_public_path__ + "static/media/logo-small.009a7079.png";